<template>
  <div>
    <div class="col-12">
      <a
        style="width: 295px"
        class="btn btn-success btn-md"
        data-target="#modalAddRuta"
        data-toggle="modal"
        href="#"
      >
        <span> Crear Nueva Ruta Reparto &nbsp; <i class="fas fa-plus"></i></span>
      </a>
    </div>
    <div
      class="modal fade"
      id="modalAddRuta"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div
          v-bind:style="
            current.tipo == 'D' ? 'background-color: #f6ffdb' : 'background-color: white;'
          "
          class="modal-content"
        >
          <div class="modal-header">
            <h6 class="modal-title">
              <h4 class="text-center">Nueva Ruta Reparto</h4>
            </h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label>Tienda</label>
                <TiendaSelectComponent titulo="" :current="current" />
              </div>
              <div class="col-12">
                <label>Descripción</label>
                <textarea
                  class="form-control"
                  style="width: 100%"
                  v-model="current.comentarios"
                  rows="2"
                  required
                ></textarea>
                <br />
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        current.errors.comentarios &&
                        current.errors.comentarios.length > 0,
                    }"
                    >Vehiculo</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.vehiculo"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option
                        v-for="(af, key) in activos_fijos"
                        :value="af.id"
                        :key="key"
                      >
                        {{ af.placa }} {{ af.nombre }} ({{ af.identificador }})
                      </option>
                    </select>
                  </div>
                  <small
                    v-if="current.errors && current.errors.vehiculo"
                    class="form-text text-danger"
                    >{{ current.errors.vehiculo[0] }}</small
                  >
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="form-group">
                  <UsuariosSelectComponent
                    :disabled="true"
                    titulo="Encargado"
                    :current="current"
                  />
                  <small
                    v-if="current.errors && current.errors.encargado"
                    class="form-text text-danger"
                    >{{ current.errors.encargado[0] }}</small
                  >
                </div>
              </div>
              <div class="col-sm-12">
                <PilotoSelectComponent :current="current" />
              </div>
            </div>
            <div class="modal-footer">
              <button @click="crearRuta" class="btn btn-primary">
                Crear ruta &nbsp; <i class="fas fa-plus"></i>
              </button>
              <button
                class="btn btn-secondary"
                ref="cerrarModal"
                data-dismiss="modal"
                type="button"
              >
                Cerrar <i class="fas fa-door-open"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import PilotoSelectComponent from "@/components/commons/PilotoSelectComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    PilotoSelectComponent,
  },
  data() {
    return {
      encargado: [],
      activos_fijos: [],
      pilotos: [],
      current: {
        piloto: null,
        tienda: null,
        comentarios: null,
        usuario: "",
        encargado: null,
        errors: {},
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {
    let self = this;
    this.refreshAF();
    this.refreshUserAutoSelect();
  },
  methods: {
    refreshUserAutoSelect() {
      let self = this;
      DynamicService.getById(
        "accounts",
        "usuarios",
        localStorage.getItem("id_usuario")
      ).then((response) => {
        self.current.usuario = response.data;
      });
    },
    refreshAF() {
      DynamicService.fetch("af", "activo").then((response) => {
        this.activos_fijos = response.data.results;
      });
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    crearRuta(e) {
      let self = this;
      e.preventDefault();
      if (self.current.usuario) {
        self.current.encargado = self.current.usuario.id;
      }
      if (self.current.piloto) {
        self.current.piloto = self.current.piloto.id;
      }
      console.log(self.current);
      DynamicService.save("cat", "viajes-reparto", self.current)
        .then((res) => {
          self.current.errors = {};
          $("#modalAddRuta").modal("hide");
          Notifications.alert.success(
            "Crear nueva ruta reparto",
            "Realizado correctamente"
          );
          Vue.nextTick(function () {
            self.$router.push({
              name: "wms-asignar-pedido-reparto-editar",
              params: { id: res.data.id },
            });
          });
        })
        .catch((error) => {
          console.log(error.response.data);
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
  },
};
</script>
